import { combineReducers } from 'redux';

import { reducer as formReducer } from 'redux-form';
import localizationReducer from './localizationReducer';
import hierarchyForm from './hierarchyReducer';

const hubfe = combineReducers({
    form: formReducer,
    hierarchy: hierarchyForm,
    localization: localizationReducer
});

export default hubfe;